import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Error from 'next/error';
// @ts-ignore
import { querySpecification } from 'flaivy-react';
import RowColTemplate from '../components/templates/RowColTemplate';
import Articles from '../components/article/Articles';
import DragDropTemplate from 'components/templates/DragDropTemplate';

function Index(props: any) {
  const { template, notFound } = props;
  const router = useRouter();
  if (notFound) {
    return <Error statusCode={404} />;
  }
  const querySpec = querySpecification.getQuerySpecification(
    router.query,
    props.querySpecification,
  );
  const searchName = router.query.searchName;
  switch (template) {
    case 'RowColTemplate':
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      return (
        <RowColTemplate {...{ ...props, querySpecification: querySpec }} />
      );
    case 'DragDrop':
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      return (
        <DragDropTemplate {...{ ...props, querySpecification: querySpec }} />
      );
    default:
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      return (
        <Articles
          {...{ ...props, querySpecification: querySpec, searchName }}
        />
      );
  }
}

Index.getInitialProps = async (ctx: any) => {
  const { req, res, query, reduxStore, asPath } = ctx;
  const shopConfig = reduxStore.getState().shopConfig;
  const { pages = [] } = shopConfig;

  let currentPage;
  const pageName = query?.path?.join('/');
  // is the current page the landingpage
  if (pageName) {
    currentPage = pages.find((x: any) => x.name === pageName);
  } else {
    currentPage = pages.find((x: any) => x.type === 'landingPage');
  }

  if (!currentPage && pageName !== 'articles') {
    if (res) {
      res.statusCode = 404;
    }
    return { notFound: true };
  }

  currentPage = currentPage || {};
  const template = _.get(currentPage, 'layout.template', 'Articles');

  const initialQuerySpecification =
    _.get(currentPage, 'layout.categories[0].orqueries') ||
    _.get(currentPage, 'layout.categories[0].query', {});

  const querySpec = querySpecification.getQuerySpecification(
    query,
    initialQuerySpecification,
  );

  delete querySpec.pageCategory;
  delete querySpec.pageName;

  const globalProps = {
    template,
    querySpecification,
    searchName: query.searchName,
  };
  let pageSpecificProps = {};

  if (template === 'RowColTemplate') {
    pageSpecificProps = await RowColTemplate.getInitialProps({
      req,
      querySpecification: querySpec,
      pageConfig: currentPage,
      shopConfig,
      searchName: query.searchName,
    });
  } else if (template === 'DragDrop') {
    pageSpecificProps = await DragDropTemplate.getInitialProps({
      req,
      querySpecification: querySpec,
      pageConfig: currentPage,
      shopConfig,
      searchName: query.searchName,
    });
  } else {
    pageSpecificProps = await Articles.getInitialProps({
      req,
      querySpecification: querySpec,
      pageConfig: currentPage,
      shopConfig,
      sort: query.sort,
      searchName: query.searchName,
    });
  }

  return { ...globalProps, ...pageSpecificProps, asPath };
};

Index.propTypes = {
  currentPage: PropTypes.object,
  template: PropTypes.string.isRequired,
};
Index.defaultProps = {
  currentPage: { layout: {} },
};
export default Index;
